export const locale = {
    lang: 'pl',
    data: {
        "Devices groups": "Grupy urządzeń",
        "New": "Nowa",
        "Name": "Nazwa",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Device group data": "Dane grupy produktów",
        "Save": "Zapisz"
    }
};
